import React from 'react'
import styled from 'styled-components'

import { colors } from 'helpers/colors'
import svgIcons from 'helpers/svgIcons'
import Button from 'components/reusable/button'
import SvgCrossMarkOutline from 'components/reusable/svg/svg_cross_mark_outline'

const StyledButton = styled(Button)`
  align-self: flex-end;
`

const SignUpAdditionalStepsCloseButton = ({ onClick }) => {
  return (
    <StyledButton type="semantic-wrapper" onClick={onClick}>
      <SvgCrossMarkOutline size={24} color={colors.gray[700]} />
    </StyledButton>
  )
}

export default SignUpAdditionalStepsCloseButton
